// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routes from "./routes/routes";

// store
import store from "./store";

//set up axios
import axios from 'axios';
import Vuex from 'vuex';

import VueClipboard from 'vue-clipboard2';

import VueLazyload from 'vue-lazyload'

import LogRocket from 'logrocket';
LogRocket.init('wdcszb/safecore-systems');

Vue.prototype.$Chartist = Chartist;
Vue.prototype.$http = axios;
//
// import VueSignaturePad from 'vue-signature-pad';


// fetch data from local storage
const token = localStorage.getItem('token');

if (token) {
  axios.defaults.headers.common["Authorization"] = token;
  console.log("token here");
  console.log(token);
}



// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(Vuex);
Vue.use(VueClipboard);
// Vue.use(VueSignaturePad);

Vue.material.locale.dateFormat = 'MM/dd/yyyy'

Vue.use(VueLazyload)
// configure router
const router = new VueRouter({
  routes,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

axios.interceptors.response.use(
  res => {
    return Promise.resolve(res);
  },
  err => {
  if (err.response.status == 401){
    if (err.response.config.url == "/users/sign_in"){
      console.log(err.response)
      return Promise.reject(err.response);
    }
    console.log(err.response)
    router.push('/portallogin')
  } else {
    return Promise.reject(err.response);
  }
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store: store,
  render: h => h(App),
  router,
  data: {
    projects: null
  }
});
